import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { StyledReceiptImage } from '../../ReceiptImage/styles/receipt-image.styled';
const RECEIPT_BANNER_IMAGE_WIDTH = '200px';
/**
 * ReceiptBanner
 */
export const receiptBannerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${pxToRem(theme.spacing[50])};

	${StyledReceiptImage} {
		margin: 0;
		width: ${pxToRem(RECEIPT_BANNER_IMAGE_WIDTH)};
	}
`;
export const StyledReceiptBanner = styled.div `
	${receiptBannerStyles}
`;
